export const tnetReviewModalTranslation = {
  titleWithTnet: 'jbp-h2-review-tnet-review-title-with-tnet',
  titleWithoutTnet: 'jbp-h2-review-tnet-review-title-without-tnet',
  helperText: 'jbp-h2-review-tnet-review-helper-text',
  summaryNeutral: 'jbp-h2-review-tnet-review-summary-neutral',
  summaryNegative: 'jbp-h2-review-tnet-review-summary-negative',
  summaryPositive: 'jbp-h2-review-tnet-review-summary-positive',
  metricColumn: 'jbp-h2-review-tnet-review-metric-column',
  actualsColumn: 'jbp-h2-review-tnet-review-actuals-column',
  planColumn: 'jbp-h2-review-tnet-review-plan-column',
  growthColumn: 'jbp-h2-review-tnet-review-growth-column',
  h1PlanColumn: 'jbp-h2-review-tnet-review-h1-plan-column',
  h1ActualsColumn: 'jbp-h2-review-tnet-review-h1-actuals-column',
  h1GrowthColumn: 'jbp-h2-review-tnet-review-h1-growth-column',
  h2PlanColumn: 'jbp-h2-review-tnet-review-h2-plan-column',
  h2GrowthColumn: 'jbp-h2-review-tnet-review-h2-growth-column',
  tnetMetric: 'jbp-h2-review-tnet-review-tnet-metric',
  goToPlanning: 'jbp-h2-review-tnet-review-go-to-planning',
  goToPlanningWithMetric: 'jbp-h2-review-tnet-review-go-to-planning-with-metric',
  confirmReview: 'jbp-h2-review-tnet-review-confirm-review',
  confirmReviewWithMetric: 'jbp-h2-review-tnet-review-confirm-review-with-metric',
  disclaimer: 'jbp-h2-review-tnet-review-disclaimer',
  confirmReviewError: 'jbp-h2-review-tnet-review-confirm-review-error',
  partnerIds: 'jbp-h2-review-tnet-review-partner-ids',
}
